import { useCallback, useEffect, useState } from "react";

export type Theme = "light" | "dark" | "system";
const KEY = "th-theme";

function apply(theme: Theme): void {
  const root = document.documentElement;
  if (theme === "system") root.removeAttribute("data-theme");
  else root.setAttribute("data-theme", theme);
}

/** Theme toggle: system → dark → light → system. Persisted to localStorage. */
export function useTheme(): { theme: Theme; cycle: () => void; set: (t: Theme) => void } {
  const [theme, setTheme] = useState<Theme>(() => {
    const saved = localStorage.getItem(KEY);
    return saved === "light" || saved === "dark" ? saved : "system";
  });

  useEffect(() => {
    apply(theme);
    localStorage.setItem(KEY, theme);
  }, [theme]);

  const cycle = useCallback(() => {
    setTheme((t) => (t === "system" ? "dark" : t === "dark" ? "light" : "system"));
  }, []);

  return { theme, cycle, set: setTheme };
}
